<template>
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
  >
    <path d="M5.26034 0.200408C5.56387 0.48226 5.58145 0.956809 5.29959 1.26034L1.77348 5L5.29959 8.73967C5.58145 9.0432 5.56387 9.51775 5.26034 9.7996C4.9568 10.0815 4.48226 10.0639 4.2004 9.76034L0.200405 5.51034C-0.0668016 5.22258 -0.0668016 4.77743 0.200405 4.48966L4.20041 0.239665C4.48226 -0.0638681 4.95681 -0.081444 5.26034 0.200408Z" />
  </svg>
</template>
